import tree from "../../../components/tree.vue"
import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import moment from 'moment';
import { domainName } from "../../../utility/index"

export default {
  name: "VehicleOperationHoursStatistics",
  components: {
    tree,
    iColumn,
    iTable,
    IPagination
  },
  data() {
    return {
      formInline: {
        data: [],
        orgId: '',
      },
      orgIdList: [],
      columnList: [],
      // 完整数据
      allData: [],
      // 显示数据
      displayData: [],

      // 懒加载相关变量
      loading: false,
      loadingMore: false,
      pageSize: 50, // 每次加载的数据量
      currentEndIndex: 50,
      hasMore: true,
      tableHeight: '',

      scrollTimer: null,
      isScrolling: false,

      monthColumns: [],
    };
  },
  created() {
    this.getDate()
    this.getOrg()
  },
  mounted() {
    this.getData()

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.$nextTick(() => {
      this.bindTableScroll();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },
  methods: {
    getDate() {
      const endTime = moment().subtract(1, "month").format("YYYY-MM");
      const startTime = moment().subtract(6, "month").format("YYYY-MM");
      this.formInline.data = [startTime, endTime];
    },
    getOrg() {
      this.$store.dispatch('tree/GET_SELECTUSERORG').then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.orgIdList = res.data.data
          }
        }
      })
    },
    setClass({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (columnIndex <= 2) {
        return 'addBorder'
      }
    },
    bindTableScroll() {
      const tableWrapper = this.$refs.dataTable?.$el?.querySelector('.el-table__body-wrapper');
      if (tableWrapper) {
        tableWrapper.addEventListener('scroll', this.handleTableScroll);
      }
    },
    handleTableScroll(event) {
      if (this.loadingMore || !this.hasMore || this.allData.length === 0) {
        return;
      }

      // 防抖处理
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      this.scrollTimer = setTimeout(() => {
        const tableWrapper = event.target || this.$refs.dataTable?.$el?.querySelector('.el-table__body-wrapper');
        if (!tableWrapper) return;

        // 计算是否滚动到底部
        const scrollTop = tableWrapper.scrollTop;
        const scrollHeight = tableWrapper.scrollHeight;
        const clientHeight = tableWrapper.clientHeight;

        // 距离底部100px时加载更多
        if (scrollHeight - scrollTop - clientHeight < 100) {
          this.loadMore();
        }
      }, 200);
    },

    extractMonthColumns() {
      this.monthColumns = [];
      this.columnList.forEach(item => {
        if (item.type === 0) {
          this.monthColumns.push(item.prop);
        }
      });
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: 1,
          colspan: 1
        };
      }

      const columnConfig = this.getColumnConfig(columnIndex);
      if (!columnConfig) {
        return { rowspan: 1, colspan: 1 };
      }

      // 判断当前列的类型
      const { prop, isAvgTime, isTotalAvgTime } = columnConfig;

      // 如果是平均作业时间列（月份列）
      if (isAvgTime) {
        return this.mergeAvgTimeByCarCount(rowIndex, prop);
      }

      // 如果是总月均作业时间列（月份列）
      if (isTotalAvgTime) {
        return this.mergeTotalAvgTimeByOrgName(rowIndex, prop);
      }

      // 其他基础列
      return this.mergeBasicColumns(rowIndex, columnConfig);
    },
    mergeAvgTimeByCarCount(rowIndex, monthProp) {
      const data = this.displayData;
      if (rowIndex >= data.length) return { rowspan: 1, colspan: 1 };

      const currentRow = data[rowIndex];
      const currentCarCount = currentRow.carCount;
      const currentOrgName = currentRow.orgName;
      const currentOrgBelowName = currentRow.orgBelowName;

      // 获取当前月份的平均作业时间值
      const monthData = currentRow[monthProp];
      const currentAvgTime = monthData ? monthData.workTimeAvg : null;

      // 如果是第一行，直接返回
      if (rowIndex === 0) {
        // 查找后面是否有相同的值可以合并
        let rowspan = 1;
        for (let i = rowIndex + 1; i < data.length; i++) {
          const nextRow = data[i];
          if (nextRow.carCount === currentCarCount &&
            nextRow.orgName === currentOrgName &&
            nextRow.orgBelowName === currentOrgBelowName) {
            const nextMonthData = nextRow[monthProp];
            const nextAvgTime = nextMonthData ? nextMonthData.workTimeAvg : null;
            if (nextAvgTime === currentAvgTime) {
              rowspan++;
            } else {
              break;
            }
          } else {
            break;
          }
        }
        return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
      }

      // 如果不是第一行，检查是否应该被合并
      const prevRow = data[rowIndex - 1];
      if (prevRow.carCount === currentCarCount &&
        prevRow.orgName === currentOrgName &&
        prevRow.orgBelowName === currentOrgBelowName) {
        const prevMonthData = prevRow[monthProp];
        const prevAvgTime = prevMonthData ? prevMonthData.workTimeAvg : null;
        if (prevAvgTime === currentAvgTime) {
          // 如果和前一行相同，则被合并，不显示
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 查找后面是否有相同的值可以合并
      let rowspan = 1;
      for (let i = rowIndex + 1; i < data.length; i++) {
        const nextRow = data[i];
        if (nextRow.carCount === currentCarCount &&
          nextRow.orgName === currentOrgName &&
          nextRow.orgBelowName === currentOrgBelowName) {
          const nextMonthData = nextRow[monthProp];
          const nextAvgTime = nextMonthData ? nextMonthData.workTimeAvg : null;
          if (nextAvgTime === currentAvgTime) {
            rowspan++;
          } else {
            break;
          }
        } else {
          break;
        }
      }

      return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
    },

    // 根据组织名称合并总月均作业时间
    mergeTotalAvgTimeByOrgName(rowIndex, monthProp) {
      const data = this.displayData;

      if (rowIndex >= data.length) return { rowspan: 1, colspan: 1 };

      const currentRow = data[rowIndex];
      const currentOrgName = currentRow.orgName;

      // 获取当前月份的总月均作业时间值
      const monthData = currentRow[monthProp];
      const currentTotalAvgTime = monthData ? monthData.workTimeAvgTotal : null;

      // 如果是第一行，直接返回
      if (rowIndex === 0) {
        // 查找后面是否有相同的值可以合并
        let rowspan = 1;
        for (let i = rowIndex + 1; i < data.length; i++) {
          const nextRow = data[i];
          if (nextRow.orgName === currentOrgName) {
            const nextMonthData = nextRow[monthProp];
            const nextTotalAvgTime = nextMonthData ? nextMonthData.workTimeAvgTotal : null;
            if (nextTotalAvgTime === currentTotalAvgTime) {
              rowspan++;
            } else {
              break;
            }
          } else {
            break;
          }
        }
        return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
      }

      // 如果不是第一行，检查是否应该被合并
      const prevRow = data[rowIndex - 1];
      if (prevRow.orgName === currentOrgName) {
        const prevMonthData = prevRow[monthProp];
        const prevTotalAvgTime = prevMonthData ? prevMonthData.workTimeAvgTotal : null;
        if (prevTotalAvgTime === currentTotalAvgTime) {
          // 如果和前一行相同，则被合并，不显示
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 查找后面是否有相同的值可以合并
      let rowspan = 1;
      for (let i = rowIndex + 1; i < data.length; i++) {
        const nextRow = data[i];
        if (nextRow.orgName === currentOrgName) {
          const nextMonthData = nextRow[monthProp];
          const nextTotalAvgTime = nextMonthData ? nextMonthData.workTimeAvgTotal : null;
          if (nextTotalAvgTime === currentTotalAvgTime) {
            rowspan++;
          } else {
            break;
          }
        } else {
          break;
        }
      }

      return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
    },

    // 合并基础列（组织名称、车辆总数等）
    mergeBasicColumns(rowIndex, columnConfig) {
      const data = this.displayData;
      if (rowIndex >= data.length) return { rowspan: 1, colspan: 1 };

      const { prop } = columnConfig;
      const currentRow = data[rowIndex];

      // 如果是组织名称列
      if (prop === 'orgName') {
        // 如果是第一行，直接返回
        if (rowIndex === 0) {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].orgName === currentRow.orgName) {
              rowspan++;
            } else {
              break;
            }
          }
          return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
        }

        // 检查是否应该被合并
        if (currentRow.orgName === data[rowIndex - 1].orgName) {
          return { rowspan: 0, colspan: 0 };
        }

        // 查找后面是否有相同的值可以合并
        let rowspan = 1;
        for (let i = rowIndex + 1; i < data.length; i++) {
          if (data[i].orgName === currentRow.orgName) {
            rowspan++;
          } else {
            break;
          }
        }
        return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
      }

      // 如果是组织管理第二列（orgBelowName）
      if (prop === 'orgBelowName') {
        const currentOrgName = currentRow.orgName;
        const currentOrgBelowName = currentRow.orgBelowName;

        // 如果是第一行，直接返回
        if (rowIndex === 0) {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            const nextRow = data[i];
            if (nextRow.orgName === currentOrgName &&
              nextRow.orgBelowName === currentOrgBelowName) {
              rowspan++;
            } else {
              break;
            }
          }
          return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
        }

        // 检查前一行是否相同（同一组织名称下的相同orgBelowName）
        const prevRow = data[rowIndex - 1];
        if (prevRow.orgName === currentOrgName &&
          prevRow.orgBelowName === currentOrgBelowName) {
          return { rowspan: 0, colspan: 0 };
        }

        // 查找后面是否有相同的值可以合并（在同一组织名称下）
        let rowspan = 1;
        for (let i = rowIndex + 1; i < data.length; i++) {
          const nextRow = data[i];
          if (nextRow.orgName === currentOrgName &&
            nextRow.orgBelowName === currentOrgBelowName) {
            rowspan++;
          } else {
            break;
          }
        }
        return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
      }

      // 如果是车辆总数列
      if (prop === 'carCount') {
        const currentOrgName = currentRow.orgName;
        const currentOrgBelowName = currentRow.orgBelowName;
        const currentCarCount = currentRow.carCount;

        // 如果是第一行，直接返回
        if (rowIndex === 0) {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            const nextRow = data[i];
            if (nextRow.orgName === currentOrgName &&
              nextRow.orgBelowName === currentOrgBelowName &&
              nextRow.carCount === currentCarCount) {
              rowspan++;
            } else {
              break;
            }
          }
          return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
        }

        // 检查前一行是否相同
        const prevRow = data[rowIndex - 1];
        if (prevRow.orgName === currentOrgName &&
          prevRow.orgBelowName === currentOrgBelowName &&
          prevRow.carCount === currentCarCount) {
          return { rowspan: 0, colspan: 0 };
        }

        // 查找后面是否有相同的值可以合并
        let rowspan = 1;
        for (let i = rowIndex + 1; i < data.length; i++) {
          const nextRow = data[i];
          if (nextRow.orgName === currentOrgName &&
            nextRow.orgBelowName === currentOrgBelowName &&
            nextRow.carCount === currentCarCount) {
            rowspan++;
          } else {
            break;
          }
        }
        return rowspan > 1 ? { rowspan, colspan: 1 } : { rowspan: 1, colspan: 1 };
      }

      // 其他列不合并
      return { rowspan: 1, colspan: 1 };
    },


    // 根据列索引获取列配置
    getColumnConfig(columnIndex) {
      // 序号列占第0列
      let currentIndex = 1; // 从第1列开始（跳过序号列）

      // 遍历columnList计算列位置
      for (let i = 0; i < this.columnList.length; i++) {
        const column = this.columnList[i];

        if (column.type === 1) {
          // 普通列，占1列
          if (currentIndex === columnIndex) {
            return {
              prop: column.prop,
              label: column.label,
              type: column.type
            };
          }
          currentIndex++;
        } else if (column.type === 0) {
          // 月份列，占3列
          // 第一子列：使用总时间
          if (currentIndex === columnIndex) {
            return {
              prop: column.prop,
              label: '使用总时间',
              type: column.type,
              isWorkTime: true,
              monthProp: column.prop
            };
          }
          currentIndex++;

          // 第二子列：平均作业时间
          if (currentIndex === columnIndex) {
            return {
              prop: column.prop,
              label: '平均作业时间',
              type: column.type,
              isAvgTime: true,
              monthProp: column.prop
            };
          }
          currentIndex++;

          // 第三子列：总月均作业时间
          if (currentIndex === columnIndex) {
            return {
              prop: column.prop,
              label: '总月均作业时间',
              type: column.type,
              isTotalAvgTime: true,
              monthProp: column.prop
            };
          }
          currentIndex++;
        }
      }

      return null;
    },
    handleResize() {
      const windowHeight = window.innerHeight;
      this.tableHeight = (windowHeight - 300) + 'px';
    },
    getData() {
      this.loading = true;
      let param = {
        userId: sessionStorage.getItem("userId"),
        orgId: this.formInline.orgId,
        startTime: this.formInline.data[0],
        endTime: this.formInline.data[1],
      }
      this.$store.dispatch('ReportAnalysis/GET_SELECTDRIVERHOMEWORKWORK', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            const rawData = res.data.data.list || [];
            this.columnList = res.data.data.label || [];
            this.extractMonthColumns();
            this.processAndSortData(rawData);

            this.initDisplayData();

            this.$nextTick(() => {
              this.$refs.dataTable?.doLayout?.()
            })
          }
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    processAndSortData(rawData) {
      // 保存所有数据
      this.allData = rawData;

      if (this.allData && this.allData.length > 0) {
        // 对数据进行排序，确保相同组织名称的数据连续，相同组织管理第二列的数据连续
        this.allData.sort((a, b) => {
          if (a.orgName < b.orgName) return -1;
          if (a.orgName > b.orgName) return 1;

          const aOrgBelowName = a.orgBelowName || '';
          const bOrgBelowName = b.orgBelowName || '';
          if (aOrgBelowName < bOrgBelowName) return -1;
          if (aOrgBelowName > bOrgBelowName) return 1;

          const aCarCount = a.carCount === undefined || a.carCount === null ? '' : a.carCount;
          const bCarCount = b.carCount === undefined || b.carCount === null ? '' : b.carCount;
          if (aCarCount < bCarCount) return -1;
          if (aCarCount > bCarCount) return 1;

          return 0;
        });
      }
    },

    initDisplayData() {
      // 计算初始显示的数据量
      const initialDataCount = Math.min(this.pageSize, this.allData.length);
      this.displayData = this.allData.slice(0, initialDataCount);
      this.currentEndIndex = initialDataCount;
      this.hasMore = this.currentEndIndex < this.allData.length;
    },

    // 加载更多数据
    loadMore() {
      if (this.loadingMore || !this.hasMore || this.allData.length === 0) {
        return;
      }

      this.loadingMore = true;

      // 模拟异步加载
      setTimeout(() => {
        // 计算新的结束位置
        const newEndIndex = Math.min(this.currentEndIndex + this.pageSize, this.allData.length);

        // 更新显示数据
        this.displayData = this.allData.slice(0, newEndIndex);
        this.currentEndIndex = newEndIndex;

        // 更新是否有更多数据
        this.hasMore = newEndIndex < this.allData.length;

        this.loadingMore = false;
      }, 300);
    },
    downCar() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportDriverHomeworkWork?orgId=${this.formInline.orgId}&startTime=${this.formInline.data[0]}&endTime=${this.formInline.data[1]}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportDriverHomeworkWork?orgId=${this.formInline.orgId}&startTime=${this.formInline.data[0]}&endTime=${this.formInline.data[1]}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        }
      }
    },
    getColumnWidth(item) {
      if (item.prop === "orgName" || item.label.includes("组织名称")) {
        return "80";
      } else if (item.prop === "carCount" || item.label.includes("车辆总数")) {
        return "80";
      } else if (item.prop === "orgBelowName") {
        return "80";
      } else if (item.prop === "driverCount") {
        return "95";
      } else {
        return "80";
      }
      return null;
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    onClear() {
      this.formInline = {
        data: [],
        orgId: '',
      }
      this.getDate()
      this.getData()
    },
  },
};